<template>
  <div>
    <generic-container
      :title="$t('pensum')"
      icon="student"
      :show_plus="true"
      :configurable="true"
      v-bind:configure_modal="configure_modal"
      v-on:add="add"
      :header_buttons="header_buttons"
    >
      <table
        class="ui blue very compact celled striped selectable table"
        ref="table"
        style="width: 100%"
      >
        <thead>
          <tr>
            <!-- <th>{{ $t("pensum name") }}</th> -->
            <th>{{ $t("name") }}</th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </generic-container>
    <pensum-modal ref="pensum_modal" />
  </div>
</template>

<script>
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import ConfigureModal from "./configuration_modal/Index.vue";
import PensumModal from "./pensum_modal/Index.vue";
import {
  //  local_api,
  init_ajax_data_datables,
  enterprise_setup,
  //  error_toast,
} from "@/utils";

// @ is an alias to /src
export default {
  name: "PensumIndex",
  components: {
    "generic-container": GenericContainer,
    PensumModal,
  },
  filters: filters,
  data() {
    return {
      pensum_list: [],
      header_buttons: [
        {
          icon: "refresh",
          tooltip: this.$t("refresh"),
          click: this.init,
        },
      ],
      configure_modal: ConfigureModal,
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    show_pensum(pensum) {
      let vm = this;
      vm.$refs.pensum_modal.showModal(pensum);
    },
    add() {
      let vm = this;
      vm.$refs.pensum_modal.showModal();
    },

    init() {
      let vm = this;

      let columns = [
        // {
        //   data: function (row) {
        //     // console.log(row);
        //     return row.student_id_card;
        //   },
        // },
        {
          data: function (row) {
            return row.name;
          },
        },
      ];

      let onSelect = (data) => {
        vm.show_pensum(data);
      };

      init_ajax_data_datables(
        vm,
        vm.$refs.table,
        window.jQuery.fn.api.settings.api["pensum url"],
        columns,
        onSelect
      );
    },
  },
  created() {},
  mounted() {
    this.init();
  },
  watch: {},
};
</script>
